<div class="puw main_dialog">
  <div class="puw__head">
    <span class="puw__eyebrow">{{ 'UpgradeToPremium' | translate }} &middot; Step {{ step }} of 3</span>
    <button type="button" class="puw__close" (click)="close()" [attr.aria-label]="'Close' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="puw__stepper">
    <div class="puw__step-dot" [class.puw__step-dot--done]="step > 1" [class.puw__step-dot--current]="step === 1">
      <span class="puw__step-num">1</span>Why Premium
    </div>
    <div class="puw__step-rule"></div>
    <div class="puw__step-dot" [class.puw__step-dot--done]="step > 2" [class.puw__step-dot--current]="step === 2">
      <span class="puw__step-num">2</span>Choose plan
    </div>
    <div class="puw__step-rule"></div>
    <div class="puw__step-dot" [class.puw__step-dot--current]="step === 3">
      <span class="puw__step-num">3</span>Review &amp; pay
    </div>
  </div>

  <div class="puw__body">
    @if (loading) {
      <div class="puw__loading">
        <div class="puw__spinner"></div>
      </div>
    } @else if (!plan) {
      <div class="puw__empty">
        <p>No premium plan is available right now. Please check back later.</p>
        <button type="button" class="btnn br_50 puw__btn-ghost" (click)="close()">Close</button>
      </div>
    } @else {

      @if (step === 1) {
        <div class="puw__panel">
          <div class="puw__hero">
            <span class="puw__hero-eyebrow">Masary Premium</span>
            <h2 class="puw__hero-title">Every partner course. One upgrade.</h2>
            <p class="puw__hero-text">Unlock the full library from Masary's learning partners — coding, virtual labs, subject courses, skills and real-world projects — all inside Masary, with your progress and badges tracked in one place.</p>
          </div>

          <div class="puw__section-label puw__section-label--accent">What you unlock</div>
          <ul class="puw__partners">
            @for (p of partners; track p.name) {
              <li>
                <span class="puw__partner-check">✓</span>
                <span><b class="puw__partner-name">{{ p.name }}</b> {{ p.desc }}</span>
              </li>
            }
          </ul>

          <div class="puw__btn-row">
            <button type="button" class="btnn br_50 puw__btn-ghost" (click)="close()">Not now</button>
            <button type="button" class="btnn br_50 puw__btn-primary" (click)="next()">Continue</button>
          </div>
        </div>
      }

      @if (step === 2) {
        <div class="puw__panel">
          <div class="puw__plan-card">
            <div class="puw__badges">
              <span class="puw__badge puw__badge--premium">Premium</span>
              @if (plan.isRecommended) {
                <span class="puw__badge puw__badge--recommended">Recommended</span>
              }
            </div>
            <div class="puw__plan-top">
              <div>
                <div class="puw__plan-name">{{ plan.name }}</div>
                <div class="puw__plan-tagline">{{ plan.tagLine }}</div>
              </div>
              <div class="puw__plan-price">
                <span class="puw__plan-amt">${{ plan.price }}</span>
                <div class="puw__plan-per">/{{ plan.expiryType === 'monthly' ? 'month' : 'year' }}</div>
              </div>
            </div>

            <div class="puw__divider"></div>

            @if (planBullets.length) {
              <div class="puw__section-label">About this package</div>
              <ul class="puw__bullets">
                @for (b of planBullets; track b) {
                  <li>{{ b }}</li>
                }
              </ul>
            }

            <button type="button" class="puw__accordion-toggle" [class.puw__accordion-toggle--open]="coursesOpen" (click)="toggleCourses()" [attr.aria-expanded]="coursesOpen">
              <span>What you get ({{ plan.coursesCount }} courses)</span>
              <mat-icon class="puw__chev">expand_more</mat-icon>
            </button>
            @if (coursesOpen) {
              <div class="puw__accordion-panel">
                <ul class="puw__course-list">
                  @for (c of plan.included_courses; track c.title) {
                    <li>
                      <span>{{ c.title }}</span>
                      <span class="puw__course-prov-icon" [attr.aria-label]="courseProviderLabel(c.courseType)" [matTooltip]="courseProviderLabel(c.courseType)">
                        <ng-container *ngTemplateOutlet="courseTypeIcon; context: { type: c.courseType?.toLowerCase() }"></ng-container>
                      </span>
                    </li>
                  }
                </ul>
              </div>
            }
          </div>

          <div class="puw__btn-row">
            <button type="button" class="btnn br_50 puw__btn-ghost" (click)="back()">← Back</button>
            <button type="button" class="btnn br_50 puw__btn-primary" (click)="next()">Continue →</button>
          </div>
        </div>
      }

      @if (step === 3) {
        <div class="puw__panel">
          <h2 class="puw__title">Review &amp; confirm</h2>
          <p class="puw__subtitle">Billed {{ plan.expiryType === 'monthly' ? 'monthly' : 'yearly' }}, cancel anytime from Manage Package.</p>

          <div class="puw__summary-box">
            <div class="puw__summary-title">Order summary &middot; billed {{ plan.expiryType === 'monthly' ? 'monthly' : 'yearly' }}</div>
            <div class="puw__summary-row"><span>{{ plan.name }}</span><b>${{ plan.price }}</b></div>
            <div class="puw__summary-total"><span class="puw__summary-lbl">Total due today</span><span class="puw__summary-val">${{ plan.price }}</span></div>
          </div>

          <label class="puw__terms">
            <input type="checkbox" [(ngModel)]="termsAccepted" name="termsAccepted" />
            I agree to the Terms of Service and understand my plan renews automatically until cancelled.
          </label>

          <div class="puw__btn-row">
            <button type="button" class="btnn br_50 puw__btn-ghost" (click)="back()" [disabled]="purchasing">← Back</button>
            <button type="button" class="btnn br_50 puw__btn-primary" (click)="purchase()" [disabled]="!termsAccepted || purchasing">
              {{ purchasing ? 'Processing…' : 'Purchase package' }}
            </button>
          </div>

          <div class="puw__secure-note">🔒 Secure checkout — you'll be redirected to Stripe</div>
          @if (!studentId) {
            <div class="puw__link-row">
              <button type="button" class="puw__btn-text" (click)="generatePaymentLink()" [disabled]="generatingLink">
                {{ generatingLink ? 'Generating…' : 'Generate a payment link instead →' }}
              </button>
            </div>
          }
        </div>
      }

    }
  </div>

  <!-- Shared course-source icon — Udemy/SCORM wordmark badges, or a plain book icon for custom content
       (no fake partner branding). Used by the Step 2 course list. -->
  <ng-template #courseTypeIcon let-type="type">
    @switch (type) {
      @case ('udemy') {
        <img class="puw__course-type-logo" src="assets/images/Udemy.svg" alt="Udemy" />
      }
      @case ('scorm') {
        <svg viewBox="0 0 32 32" width="20" height="20" aria-hidden="true">
          <rect x="0" y="0" width="32" height="32" rx="8" fill="#1E6FB5"></rect>
          <text x="16" y="21" text-anchor="middle" font-size="12" font-weight="700" fill="#fff" font-family="Arial, sans-serif">S</text>
        </svg>
      }
      @default {
        <mat-icon>menu_book</mat-icon>
      }
    }
  </ng-template>
</div>
